import React, { useEffect, useRef, useState } from 'react'
import { Modal, Button, Form, Divider, Tooltip, message, Row, Select, Spin, Collapse, Popover } from 'antd'
import { connect } from 'react-redux'
import './index.scss'
import { MinusSmallIco, ModalCloseIco, PlusSmallIco, SaveBlueIco, SpinnerIco } from '../../../modules/CustomIcons'
import TableComponent from 'components/Table'
import { LOGIN_PAGE } from 'constants/constants'
import { CountdownCircleTimer } from 'react-countdown-circle-timer'
import asanLogo from 'assets/images/icons/asan-logo.png'
import questionMark from 'assets/images/icons/question.png'
import SuccessOrErrorModal from 'components/SuccessOrErrorModal'
import {
    getTransactionButtons,
    RuleTransactionButton,
} from '../../services/Auth/RuleTransactionButton'
import { API_URL, httpVeryfied } from '../../services/config'
import OtpInput from 'react-otp-input'
import Timer from 'components/Timer'
import '../../pages/Login/components/Sidebar/MessageInput/index.scss'
import { getTransactionStatus } from '../../services/Auth/TransactionStatus'
// import {changeStatus} from '../../store/actions/transfers'
import { Scrollbar } from 'smooth-scrollbar-react'
import type { Scrollbar as BaseScrollbar } from 'smooth-scrollbar/scrollbar'
import { useActions } from '../../hooks/useActions'
import { changeStatusHandler } from 'store/actions/transfers'
import { convertBase64, resetForm } from "../../services/helper";
import { uploadFile } from "../../services/Transfers/Files";
import {
    footerBtnsFirstModal,
    footerBtnsSecondSalary
} from "pages/Transfers/StatusRender";
import SaveAsTemplate from "components/SaveAsTemplate";
import { getAllFilesOrderExcel, getAllFilesOrderPdfByName } from "../../services/transfers";
import { secureLocalStorageGet } from '../../helpers'
import {useTranslation} from "react-i18next";

const formatRemainingTime = (time: number) => {
    const minutes = Math.floor((time % 1200) / 60)
    const seconds = time % 60

    return `0${minutes}:${seconds == 0 || seconds < 10 ? `0${seconds}` : seconds}`
}

const renderTime = ({ remainingTime }) => {
    if (remainingTime === 0) {
        return <div className="timer"></div>
    }

    return (
        <div className="timer">
            <div className="value">{formatRemainingTime(remainingTime)}</div>
        </div>
    )
}



const NextModalSalary: React.FC<any> = (props: any) => {
    const {t} = useTranslation()
    const text = (
        <div className="ant-tooltip-inner__data">{t("settings.asanInfo")}<br />
            <span><a href='https://www.asanimza.az' target="_blank">www.asanimza.az</a></span>
        </div>
    )
    let custom_class = props.className || ''
    const [nextModalVisible, setNextModalVisible] = useState(
        props.visible || false
    )
    const [asanModalVisible, setAsanModalVisible] = useState(false)
    const [otpCodeModalVisible, setOtpCodeModalVisible] = useState(false)
    const [showSuccessOrError, setShowSuccessOrError] = useState(false)
    const [showTimeError, setShowTimeError] = useState(false)
    const [transactionButtonsStatus, setTransactionButtonsStatus] = useState<RuleTransactionButton>()
    const [verifyCode, setVerifyCode] = useState<number>()
    const [phoneNumber, setPhoneNumber] = useState<string>()
    const [otpNumberCount, setOtpNumberCount] = useState<number>(6)
    const [otpCode, setOtpCode] = useState<number[]>([])
    const [otpCodeHasError, setOtpCodeHasError] = useState<boolean>(false)
    const modalData = props.data
    const [popupType, setPopupType] = useState("success")
    const [form] = Form.useForm()
    const scrollbar = useRef<BaseScrollbar | null>(null)
    const [minutes, setMinutes] = useState<number>(5)
    const [reset, setReset] = useState<boolean>(false)
    const [modalText, setModalText] = useState<string>(props.nextModalText)
    const [loading, setLoading] = useState<boolean>(false)
    const [loadingApprove, setLoadingApprove] = useState<boolean>(false)
    const [errorService, setErrorService] = useState("")
    const [saveAsTemplatePopupVisible, setSaveAsTemplatePopupVisible] = useState<boolean>(false);
    let channel = secureLocalStorageGet('channel')
    const [smsClicked, setClicked] = useState(true)
    const selectOptions = ['AZ', 'EN','RU']
    const { Panel } = Collapse
    const [activePanel, setPanel] = useState(false)
    const [activePanelNotify, setPanelNotify] = useState(false)
    const [multipleButton, setMultipleButton] = useState(false)
    const [footerBtnsSecond, setFooterBtnsSecond] = useState(footerBtnsSecondSalary)
    const [footerBtnsFirst, setFooterBtnsFirst] = useState(footerBtnsFirstModal)
    const [visible, setVisible] = useState(false);
    const [loadingExcel, setLoadingExcel] = useState(false);
    const [selectLang,setLanguage] = useState('AZ')
    const content = (
        <div>
            <p onClick={props.handleGetFileClick} className={'pdf_text'}>{t("transfers.seperatePDF")}</p>
            <p onClick={props.handleGetFileClickMultiple} className={'pdf_text'}>{t("transfers.multiplePDF")}</p>
        </div>
    );

    useEffect(() => {
        setErrorService("")
        setModalText(props.nextModalText)
        setNextModalVisible((old_value) => props.visible)
        if (!props.source) {
            getTransactionButtons().then((res) => {
                setTransactionButtonsStatus((olda_data) => res)
            })
        }
    }, [props.visible, props.data])

    useEffect(() => {
        setLanguage('AZ')
        setPanel(false)
        setPanelNotify(false)
        let template = false;
        if (props.data !== undefined && props.data['modalTitle'] === t("home.currencyExchange"))
            template = true;
        if (props.btnData !== undefined && props.btnData !== {}) {
            footerBtnsSecond[0]['visible'] = props.btnData['singlePdfButton'];
            footerBtnsSecond[1]['visible'] = props.btnData['excelButton'];
            footerBtnsSecond[2]['visible'] = props.btnData['swiftButton'];
            footerBtnsSecond[3]['visible'] = props.btnData['adocButton'];
            footerBtnsFirst[0]['visible'] = props.btnData['repeatButton'];
            footerBtnsFirst[1]['visible'] = props.btnData['editButton'];
            if (!template)
                footerBtnsFirst[2]['visible'] = props.btnData['saveAsTemplateButton'];
            else
                footerBtnsFirst[2]['visible'] = false;
            footerBtnsFirst[3]['visible'] = props.btnData['deleteButton'];
        } else {
            footerBtnsSecond[0]['visible'] = false;
            footerBtnsSecond[1]['visible'] = false;
            footerBtnsSecond[2]['visible'] = false;
            footerBtnsFirst[0]['visible'] = false;
            footerBtnsFirst[1]['visible'] = false;
            footerBtnsFirst[2]['visible'] = false;
            footerBtnsFirst[3]['visible'] = false;
        }
        if (props.multiple) {
            setMultipleButton(true);
        }
        else {
            setMultipleButton(false);
        }
    }, [props.selectedType, props.multiple, props.data])

    const onClose = () => {
        //props.onClose((old_value) => false)

        setNextModalVisible(false)
        setAsanModalVisible(false)
        setOtpCodeModalVisible(false)
        setShowSuccessOrError(false)

        /*setTimeout(() => {
          window.location.reload();
        }, 500)*/
    }

    const onCloseModal = () => {
        props.onClose((old_value) => false)

        setNextModalVisible(false)
        setAsanModalVisible(false)
        setOtpCodeModalVisible(false)
        setShowSuccessOrError(false)

        /*setTimeout(() => {
          window.location.reload();
        }, 500)*/
    }

    const onCloseSuccessModal = () => {

        if (props.onCloseSuccessModal !== null && props.onCloseSuccessModal !== undefined) {
            props.onCloseSuccessModal((old_value) => false)
        }

        props.onClose((old_value) => false)
        setNextModalVisible(false)
        setAsanModalVisible(false)
        setOtpCodeModalVisible(false)
        setShowSuccessOrError(false)

        /*setTimeout(() => {
          window.location.reload();
        }, 500)*/
    }

    const showSuccessModal = () => {
        setShowSuccessOrError(old_status => true);
        if (props.currentForm) {
            resetForm(props.currentForm)
        }
    }

    const showAsanModal = () => {
        // setNextModalVisible(false)
        setAsanModalVisible(true)
    }

    const showOtpCodeModal = () => {
        // setNextModalVisible(false)
        setOtpCodeModalVisible(true)
        setClicked(false)
        setOtpCode((old_data) => [])
        setOtpCodeHasError((old_data) => false)
    }

    const hideOtpCodeModal = () => {
        setNextModalVisible(true)
        setOtpCodeModalVisible(false)
    }

    const checkAsanVerifyCode = (code: number) => {
        setPopupType("success")
        return new Promise((resolve, reject) => {
            function checkResponse() {
                httpVeryfied()
                    .get(`${API_URL}transaction/status/${code}`)
                    .then((response: any) => {
                        let data = response.data.data
                        if (data?.lastStatus == 'SIGNATURE_CREATED' && response?.data?.status == 'SUCCESS') {
                            if (data?.trnDetails !== undefined && data?.trnDetails !== null && data?.trnDetails.length > 0 && data?.trnDetails[0].status === "WARN")
                                setModalText(t("notification.sentToBank"))
                            else if (data?.trnDetails !== undefined && data?.trnDetails !== null && data?.trnDetails.length > 0 && data?.trnDetails[0].status === "OUTOF")
                                setModalText(t("notification.sentToBankAndProcessedNextDay"));
                            else if (data?.trnDetails[0].trnStatus === "BANK_SUCCESS") {
                                setModalText(t("notification.transferSentToBank"));
                            }
                            else
                                setModalText(t("notification.transferCreatedSigned"));
                            setPopupType('success');
                            setAsanModalVisible(false)
                            showSuccessModal();
                        } else if (data?.lastStatus == 'OUTSTANDING_TRANSACTION') {
                            window.setTimeout(checkResponse, 1000)
                        } else {
                            setAsanModalVisible(false)
                            setModalText(response.data.message !== null ? response.data.message : "")
                            setPopupType("error")
                            showSuccessModal();
                        }
                    }).catch((e) => {
                    setAsanModalVisible(false)
                    setShowSuccessOrError(true)
                    setPopupType("error")
                    setModalText(t("notification.errorOccured"))
                })
            }
            checkResponse()
        })
    }

    const checkAsanVerifyCodeTransfers = (code: number) => {
        setPopupType("success")
        return new Promise((resolve, reject) => {
            function checkResponse() {
                httpVeryfied()
                    .get(`${API_URL}transaction/status/${code}`)
                    .then((response: any) => {
                        let data = response.data.data
                        if (data.lastStatus == 'SIGNATURE_CREATED' && response.data.status == 'SUCCESS') {
                            if (data?.trnDetails !== undefined && data?.trnDetails !== null && data?.trnDetails.length > 0 && data?.trnDetails[0].status === "WARN")
                                setModalText(t("notification.sentToBank"))
                            else if (data?.trnDetails !== undefined && data?.trnDetails !== null && data?.trnDetails.length > 0 && data?.trnDetails[0].status === "OUTOF")
                                setModalText(t("notification.sentToBankAndProcessedNextDay"));
                            else if (data?.trnDetails[0].trnStatus === "BANK_SUCCESS") {
                                setModalText(t("notification.transferSentToBank"));
                            }
                            else
                                setModalText(t("notification.transferCreatedSigned"));
                            setPopupType('success');
                            setAsanModalVisible(false)
                            showSuccessModal();
                        } else if (data.lastStatus == 'OUTSTANDING_TRANSACTION') {
                            window.setTimeout(checkResponse, 1000)
                        } else {
                            setAsanModalVisible(false)
                            setModalText(response.data.message !== null ? response.data.message : "")
                            setPopupType("error")
                            showSuccessModal();
                        }
                    }).catch((e) => {
                    setAsanModalVisible(false)
                    setShowSuccessOrError(true)
                    setPopupType("error")
                    setModalText(t("notification.errorOccured"));
                })
            }
            checkResponse()
        })
    }

    const saveFilesExcel = async (PMTID: string, pdfFiles: any) => {
        let returnValue = false;
        let fileDetailsList = {
            'fileDetailsList': []
        };
        if (pdfFiles && pdfFiles.length > 0) {
            for (let file of pdfFiles) {
                let convert = await convertBase64(file);

                fileDetailsList['fileDetailsList'].push({
                    fileBase64: convert,
                    pmtid: PMTID,
                    fileName: file.name,
                    mimeType: "application/vnd.ms-excel"
                })
            }
            const res = await uploadFile(fileDetailsList);
            if (res?.status === "SUCCESS")
                returnValue = true;
        }

        return returnValue

    }
    // console.log("aaa",props.transferSp === true ? props.tableData['TRANSACTION_EMPLIST'] : props.tableData);
    
    const saveFiles = async (ibankRef: string, PMTID: string) => {
        let formData = props.data;
        let pdfFiles = formData.pdfFiles;
        let fileDetailsList = {
            'fileDetailsList': []
        };
        if (pdfFiles && pdfFiles.length > 0) {
            for (let file of pdfFiles) {
                let convert = await convertBase64(file.file.originFileObj !== undefined ? file.file.originFileObj : file.file);

                fileDetailsList['fileDetailsList'].push({
                    fileBase64: convert,
                    pmtid: PMTID,
                    fileName: file.file.name,
                    mimeType: file.file.type
                })
            }

            uploadFile(fileDetailsList);
        }

    }

    const sendTransactionRequest = async (RequestType: string, retry: boolean) => {
        setModalText(props.nextModalText);
        setPopupType('success');
        setErrorService("")
        // setClicked(false)
        if (RequestType === 'SAVE')
            setLoading(true)
        else
            setLoadingApprove(true)
        let response = true;
        props.callBackApi(RequestType, retry, props.fileListSalary).then((res: any) => {
            setLoading(false)
            setLoadingApprove(false)
            if (res?.status === "SUCCESS" || res?.resultMessage === "SUCCESS") {
                saveFiles(res.data?.ibankRef, res.data?.PMTID);
                if (props.fileListSalary !== undefined && props.fileListSalary !== [])
                    saveFilesExcel(res.data?.PMTID, props.fileListSalary)
                if (RequestType === 'SAVE') {
                    onClose();
                    setModalText(t("notification.transferCreated"));
                    setPopupType('success');
                    showSuccessModal();
                } else if (RequestType === 'APPROVE') {
                    if (props.transferSP) {
                        if (res?.fileDescriptors !== undefined && res?.fileDescriptors !== null && res?.fileDescriptors.length > 0 && res?.fileDescriptors[0]?.status === "WARN")
                            setModalText(t("notification.sentToBank"))
                        else if (res?.fileDescriptors !== undefined && res?.fileDescriptors !== null && res?.fileDescriptors.length > 0 && res?.fileDescriptors[0]?.status === "OUTOF")
                            setModalText(t("notification.sentToBankAndProcessedNextDay"));
                        else
                            setModalText(t("notification.transferConfirmed"));
                    }
                    else {
                        if (res?.fileDescriptors !== undefined && res?.fileDescriptors !== null && res?.fileDescriptors.length > 0 && res?.fileDescriptors[0]?.trnStatus === "BANK_SUCCESS") {
                            setModalText(t("notification.transferSentToBank"));
                        } else
                            setModalText(t("notification.transferCreatedConfirmed"));
                    }
                    setPopupType('success');
                    // setNextModalVisible(false)
                    showSuccessModal();
                }
                else {
                    let channel = secureLocalStorageGet('channel')
                    if (channel === 'TOTP' || channel === 'OTP') {
                        // let phone_number = localStorage.getItem('phoneNumber');
                        let phone_number = secureLocalStorageGet('phoneNumber')
                        if (phone_number === undefined || phone_number === "" || phone_number === null)
                            phone_number = res?.data?.phoneNumber
                        if (phone_number !== undefined && phone_number !== "" && phone_number !== null) {
                            let last_4_number = phone_number.slice(-4)
                            let make_phone_number =
                                last_4_number[0] +
                                last_4_number[1] +
                                '-' +
                                last_4_number.slice(-2)
                            setPhoneNumber((old_data) => make_phone_number)
                        }
                        setOtpNumberCount((old_number) => (channel === 'TOTP' ? 6 : 5))

                        showOtpCodeModal()
                    } else {
                        let verify_code = res.data.verification
                        setVerifyCode((old_code) => verify_code)
                        checkAsanVerifyCode(verify_code)
                        showAsanModal()
                    }
                }
            } else {
                setLoading(false)
                setLoadingApprove(false)
                if (res?.resultCode !== "500") {
                    setErrorService((res?.detail !== undefined ? res?.detail : '' + ' ') + (res?.message !== undefined ? res?.message : '' + ' ') + (res?.resultMessage !== undefined ? res?.resultMessage : ''));
                } else {

                    setNextModalVisible(false)
                    setShowSuccessOrError(true)
                    setModalText(t("notification.errorOccuredWhenSendToBank"));
                    setPopupType('error');
                }
            }
        }).catch((e: any) => {
            setLoading(false)
            setLoadingApprove(false)
            setErrorService(e?.data?.detail)
        })
    }

    const sendTransactionApprove = async (RequestType: any, retry: boolean) => {
        setModalText(props.nextModalText);
        setPopupType('success');
        setErrorService("");
        setLoadingApprove(true)
        let response = true;
        props.callBackApi(RequestType, retry, props.fileListSalary).then((res) => {
            // saveFilesExcel(res.data?.ibankRef, res.data?.PMTID, props.fileListSalary)
            if (props.fileListSalary !== undefined)
                saveFilesExcel(res.data?.PMTID, props.fileListSalary)
            setLoadingApprove(false)
            if (res?.status === "SUCCESS" || res?.resultMessage === "SUCCESS") {
                if (RequestType === 'APPROVE') {
                    if (props.transferSP) {
                        if (res?.fileDescriptors !== undefined && res?.fileDescriptors !== null && res?.fileDescriptors.length > 0 && res?.fileDescriptors[0]?.status === "WARN")
                            setModalText(t("notification.sentToBank"))
                        else if (res?.fileDescriptors !== undefined && res?.fileDescriptors !== null && res?.fileDescriptors.length > 0 && res?.fileDescriptors[0]?.status === "OUTOF")
                            setModalText(t("notification.sentToBankAndProcessedNextDay"));
                        else
                            setModalText(t("notification.transferConfirmed"));
                    }
                    else
                        setModalText(t("notification.transferCreatedConfirmed"));
                    setPopupType('success');
                    setNextModalVisible(false)
                    showSuccessModal();
                } else {
                    let channel = secureLocalStorageGet('channel')
                    if (channel === 'TOTP' || channel === 'OTP') {
                        // let phone_number = localStorage.getItem('phoneNumber');
                        let phone_number = secureLocalStorageGet('phoneNumber');
                        let last_4_number = phone_number.slice(-4)
                        let make_phone_number =
                            last_4_number[0] + last_4_number[1] + '-' + last_4_number.slice(-2)
                        setPhoneNumber((old_data) => make_phone_number)
                        setOtpNumberCount((old_number) => (channel === 'TOTP' ? 6 : 5))
                        showOtpCodeModal()
                    } else {
                        setVerifyCode((old_code) => res.verfication)
                        showAsanModal()
                        checkAsanVerifyCodeTransfers(res.verfication)
                    }
                }
            } else {
                if (res?.resultCode !== "500") {
                    setErrorService((res?.detail !== undefined ? res?.detail : '' + ' ') + (res?.message !== undefined ? res?.message : '' + ' ') + (res?.resultMessage !== undefined ? res?.resultMessage : ''));
                } else {

                    setNextModalVisible(false)
                    setShowSuccessOrError(true)
                    setModalText(t("notification.errorOccuredWhenSendToBank"));
                    setPopupType('error');
                }
            }
        }).catch((e) => {
            setLoading(false)
            setLoadingApprove(false)
            setErrorService(e?.data?.detail)
        })
        setLoadingApprove(false)
    }

    const handleTransactionReq = async () => {
        if (props.btnType) {
            await sendTransactionApprove(props.requestType, false)
        } else {
            await sendTransactionRequest('SIGN', false)
        }
    }

    const handleValue = (value: any) => {
        setOtpCode(value)
    }
    // console.log("aaw",props.transferSp === true ? props.tableData['TRANSACTION_EMPLIST'] : props.tableData);
    
    const checkOTPCode = () => {
        setModalText(props.nextModalText);
        setPopupType('success');
        if (otpCode.length == 5 || otpCode.length == 6) {
            getTransactionStatus(otpCode).then((res) => {
                if (res.status === 'ERROR' && res.code === 3) {
                    setOtpCodeHasError((old_data) => true)
                }else if(res.status === 'ERROR' && res.code === 5){
                    setOtpCodeHasError((old_data) => true)

                } else if (res.status === 'ERROR' && res.code === 500) {
                    if (res?.data?.trnDetails[0].status === "LIMIT") {
                        setModalText(t("notification.carriedOutPayment"))
                        setPopupType('error');
                        showSuccessModal();
                    } else {
                        setOtpCodeHasError((old_data) => false)
                        setOtpCodeModalVisible(false)
                        setModalText(t("notification.errorOccuredWhenSendToBank"));
                        setPopupType('error');
                        showSuccessModal();
                    }
                }
                else {
                    if (props.modalType === undefined || props.modalType === null) {
                        if (res?.data?.trnDetails[0].status === "WARN")
                            setModalText(t("notification.sentToBank"))
                        else if (res?.data?.trnDetails[0].status === "OUTOF")
                            setModalText(t("notification.sentToBankAndProcessedNextDay"));
                        else if (res?.data?.trnDetails[0].trnStatus === "BANK_SUCCESS") {
                            setModalText(t("notification.transferSentToBank"));
                            setPopupType('success');
                        }
                        else
                            setModalText(t("notification.transferCreatedSigned"));
                        setPopupType('success');
                        setOtpCodeHasError(() => false)
                        setOtpCodeModalVisible(false)
                        showSuccessModal();
                    } else {
                        if (res?.data?.trnDetails[0].status !== "" && res?.data?.trnDetails[0].status !== undefined && res?.data?.trnDetails[0].status !== null)
                            setModalText(t("notification.sentToBank"))
                        if (res?.data?.trnDetails[0].trnStatus === "BANK_ERROR")
                            if (res?.data?.trnDetails[0].status === "LIMIT")
                            {
                                setModalText(res?.data?.trnDetails[0].message)
                                setPopupType('error');
                            } else {
                                setModalText(t("notification.errorOccuredWhenSendToBank"));
                            }                        else if (res?.data?.trnDetails[0].trnStatus !== "BANK_SUCCESS") {
                            if (res?.data?.userRole === "SIGNER")
                                setModalText(t("notification.transferSigned"));
                            else
                                setModalText(t("notification.transferConfirmed"));
                            setPopupType('success');
                        } else if (props.selectedType === "BANK_ERROR") {
                            setModalText(t("notification.transferSentToBank"));
                            setPopupType('success');
                        }
                        setOtpCodeHasError((old_data) => false)
                        setOtpCodeModalVisible(false)
                        showSuccessModal();
                    }
                    // props.onStatusChange(true)
                }
            }).catch((e) => {
                setOtpCodeModalVisible(false)
                setShowSuccessOrError(true)
                setPopupType("error")
                setModalText(t("notification.errorOccured"))
            })
        }
    }

    const resetFormTimer = () => {
        setOtpCodeModalVisible(false)
        setShowTimeError(true)
        // inputRef.current.__clearvalues__()
    }

    const reSend = () => {
        if (smsClicked) {
            setClicked(false)
            sendTransactionRequest('SIGN', true);
        }
        // setMinutes(5);
        // setReset(true);
        // setTimeout(() => setReset(false), 1000);
    }

    const downloadPDF = async (file: any) => {
        let fileBase64 = await convertBase64(file.file.originFileObj !== undefined ? file.file.originFileObj : file.file);
        const fileName = file.label;
        const linkSource = `${fileBase64}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    }

    const handleSave = () => {
        setSaveAsTemplatePopupVisible(old_data => true)
    }

    useEffect(
        () => {
            if (!smsClicked) {
                let timer1 = setInterval(() => setClicked(true), 20 * 1000);
                return () => {
                    clearInterval(timer1);
                }
            }
        },
        [smsClicked]
    );

    const handleGetExcelAdditional = async () => {
        setLoadingExcel(true)
        try {
            const data = await getAllFilesOrderExcel(props.openedIbanRef,selectLang)
            data?.data.fileDetailsList.map(function (item, i) {
                const linkSource = `data:${item.mimeType};base64,${item.fileBase64}`
                const downloadLink = document.createElement('a')
                downloadLink.href = linkSource
                downloadLink.download = item.fileName
                downloadLink.click()
            })
        } catch (e) { }
        setLoadingExcel(false)
    }
    // console.log("a",props?.transferSp);
    
    // @ts-ignore
    const modalFooter = () => (
        <>
            {modalData.note && (
                <div className="flex tab_info_box ">
                    <span
                        className="passive_text_box passive_text_box_rel"
                        dangerouslySetInnerHTML={{ __html: modalData.note }}
                    />
                </div>
            )}

            {modalData.alertText && (
                <div className="flex tab_info_box tab_alert_box">
        <span
            className="passive_text_box passive_text_box_rel"
            dangerouslySetInnerHTML={{ __html: modalData.alertText }}
        />
                </div>
            )}

            {errorService && (
                <div className="flex tab_info_box tab_alert_box">
        <span
            className="passive_text_box passive_text_box_rel"
            dangerouslySetInnerHTML={{ __html: errorService }}
        />
                </div>
            )}
            {props.transferSP ?
                <div className={'flex flex_wrap modalTransferSpaceBetween'}>
                    <div className="transfers-footer_btns1 transfers-footer_btns--modal flex" style={{ position: 'relative', bottom: 12 }}>
                        {!multipleButton && <ul className="flex">
                            <li>
                                <div className="pagination-selector language-selector"
                                     style={{ left: '0px' }}
                                >
                                    <Select
                                        // open={true}
                                        defaultValue={'AZ'}
                                        placeholder="AZ"
                                        // width={64}
                                        onChange={(value:any) => setLanguage(value)}
                                    >
                                        {selectOptions.map((item) => {
                                            return <option value={item}>{item}</option>
                                        })}
                                    </Select>
                                </div>
                            </li>
                            {footerBtnsSecond.map((item) => {
                                return (
                                    item.visible &&
                                    <li>
                                        <Tooltip className="footer-tooltip" title={item.title}>
                                            {item.key == 'pdf' ?
                                                props.loadingPdf ?
                                                    <div className='ant-btn exportLoadingdiv'><Spin indicator={<SpinnerIco />} /></div>
                                                    :
                                                    props.multiple ?
                                                        <Popover
                                                            // className = "btn-popover"
                                                            placement="top"
                                                            content={content}
                                                            trigger="click"
                                                            visible={visible}
                                                            onVisibleChange={() => setVisible(!visible)}
                                                        >
                                                            <Button
                                                                icon={item.icon}
                                                                disabled={!item.visible || loadingApprove}
                                                            />
                                                        </Popover> :
                                                        <Button
                                                            icon={item.icon}
                                                            disabled={!item.visible || loadingApprove}
                                                            onClick={()=>
                                                                props.handleGetFileClick(selectLang)
                                                            }
                                                        /> :
                                                loadingExcel ?
                                                    <div className='ant-btn exportLoadingdiv'><Spin indicator={<SpinnerIco />} /></div>
                                                    :
                                                    <Button
                                                        icon={item.icon}
                                                        disabled={!item.visible || loadingApprove || item.key == 'swift'}
                                                        onClick={
                                                            item.key == 'adoc'
                                                                ? props.handleGetAdocFileClick
                                                                : handleGetExcelAdditional
                                                        }
                                                    />
                                            }

                                        </Tooltip>
                                    </li>
                                )
                            })}
                        </ul>
                        }
                        {!multipleButton && <ul
                            className="flex"
                            style={{ marginRight: '86px' }}
                        >
                            {footerBtnsFirst.map((item) => {
                                return (
                                    item.visible && <li>
                                        <Tooltip className="footer-tooltip" title={item.title}>
                                            <Button
                                                ghost
                                                icon={item.icon}
                                                disabled={!item.visible || loadingApprove}
                                                onClick={
                                                    item.type === 'repeat'
                                                        ? props.handleRepeat
                                                        : item.type === 'edit'
                                                        ? props.handleEdit
                                                        : item.type === 'save'
                                                            ? handleSave
                                                            : props.handleDelete
                                                }
                                            />

                                        </Tooltip>
                                    </li>
                                )
                            })}
                        </ul>
                        }
                    </div>

                    <div className={"flex"}>
                        {props.requestType === 'SIGN' && props.selectedType !== "BANK_ERROR" ? (
                            <div className={"modalButtonDivSignTransfer"}>
                                {
                                    loadingApprove ?
                                        <div className='ant-btn  exportLoadingdiv transfer_loading'><Spin indicator={<SpinnerIco />} />
                                        </div>
                                        :
                                        !props.disabledSign && <Button
                                            size={'large'}
                                            htmlType="submit"
                                            className="blue-button next_btn btn flex align_center justify_center"
                                            disabled={props.disabledSign}
                                            onClick={handleTransactionReq}
                                        >
                                            {t("transfers.sign")}
                                        </Button>
                                }
                            </div>
                        ) : (props.selectedType !== "BANK_ERROR" &&
                            <div className={"modalButtonDivApproveTransfer"}>
                                {
                                    loadingApprove ?
                                        <div className='ant-btn exportLoadingdiv transfer_loading'><Spin indicator={<SpinnerIco />} />
                                        </div>
                                        :
                                        <Button
                                            size={'large'}
                                            htmlType="submit"
                                            className="blue-button next_btn btn flex align_center justify_center"
                                            disabled={props.selectedType === "DELETED" || props.disabledSign}
                                            onClick={() => {
                                                sendTransactionRequest(props.btnType || 'APPROVE', false)
                                            }}
                                        >
                                            {t("login.confirm")}
                                        </Button>
                                }
                            </div>
                        )}
                        {
                            props.selectedType === "BANK_ERROR" &&
                            <div className={"modalButtonDivApproveTransfer"}>
                                {
                                    loadingApprove ?
                                        <div className='ant-btn exportLoadingdiv transfer_loading'><Spin indicator={<SpinnerIco />} />
                                        </div>
                                        :
                                        <Button
                                            size={'large'}
                                            htmlType="submit"
                                            className="blue-button next_btn btn flex align_center justify_center"
                                            onClick={() => {
                                                sendTransactionRequest("SEND_BANK", false)
                                            }}
                                        >
                                            {t("transfers.sendToBank")}
                                        </Button>
                                }
                            </div>
                        }
                        <Button
                            size={'large'}
                            htmlType="submit"
                            className="light-button refresh_btn next_modal_cancel_btn btn flex align_center justify_center"
                            onClick={onClose}
                            disabled={loadingApprove}
                        >

                            {t("common.close")}
                        </Button>
                    </div>
                </div>
                :
                <div className={'flex' + props.source ? props.className : ''}>
                    <div className={'flex flex_wrap align_center justify_end'}>
                        {modalData.buttons &&
                        Array.isArray(modalData.buttons) &&
                        modalData.buttons.map((btn) => {
                            let btn_item = <></>

                            if (btn.patternButton) {
                                btn_item = (
                                    <Button
                                        size={'large'}
                                        icon={<SaveBlueIco />}
                                        className="light-button btn save_btn flex align_center justify_center refresh_btn next_modal_cancel_btn"
                                        htmlType="submit"
                                        disabled={loading || loadingApprove}
                                        onClick={onCloseModal}
                                    >
                                        {t("newTransfer.saveAsTemplate")}
                                    </Button>
                                )
                            }
                            else if (btn.sign && transactionButtonsStatus?.sign) {
                                //sign
                                btn_item = (
                                    <div className={"modalButtonDivSign"}>
                                        {
                                            loadingApprove ?
                                                <div className='ant-btn  exportLoadingdiv transfer_loading'><Spin
                                                    indicator={<SpinnerIco />} />
                                                </div>
                                                :
                                                <Button
                                                    size={'large'}
                                                    htmlType="submit"
                                                    className="blue-button next_btn btn flex align_center justify_center"
                                                    disabled={modalData.alertText !== undefined && modalData.alertText !== '' || loading}
                                                    onClick={handleTransactionReq}
                                                >
                                                    {t("transfers.sign")}
                                                </Button>
                                        }
                                    </div>
                                )
                            }
                            else if (btn.approve && transactionButtonsStatus?.approve) {
                                //approve
                                btn_item = (
                                    <div className={"modalButtonDivApprove"}>
                                        {
                                            loadingApprove ?
                                                <div className='ant-btn exportLoadingdiv transfer_loading'><Spin indicator={<SpinnerIco />} />
                                                </div>
                                                :
                                                <Button
                                                    size={'large'}
                                                    htmlType="submit"
                                                    className="blue-button next_btn btn flex align_center justify_center"
                                                    disabled={modalData.alertText !== undefined && modalData.alertText !== '' || loading}
                                                    onClick={() => {
                                                        sendTransactionRequest(props.btnType || 'APPROVE', false)
                                                    }}
                                                >
                                                    {t("transfers.approve")}
                                                </Button>
                                        }
                                    </div>
                                )
                            }
                            else if (btn.save && transactionButtonsStatus?.save && !props.btnType) {
                                //save
                                btn_item = (
                                    <div>
                                        {loading ?
                                            <div className='ant-btn exportLoadingdiv transfer_loading'><Spin indicator={<SpinnerIco />} />
                                            </div>
                                            : <Button
                                                size={'large'}
                                                htmlType="submit"
                                                className="blue-button next_btn btn flex align_center justify_center"
                                                disabled={modalData.alertText !== undefined && modalData.alertText !== '' || loadingApprove}
                                                onClick={() => {
                                                    sendTransactionRequest(props.btnType || 'SAVE', false)
                                                }}
                                            >
                                                { props.editTransfer ? t("transfers.save") : t("newTransfer.create") }
                                            </Button>
                                        }
                                    </div>
                                )
                            }
                            else if (btn.send && transactionButtonsStatus?.send) {
                                //send
                                /*btn_item=<Button
                                    size={'large'}
                                    className="light-button refresh_btn next_modal_cancel_btn btn flex align_center justify_center"
                                    onClick={() => { sendTransactionRequest("SIGN_AND_SEND_BANK") } }
                                >
                                  İmzala və Banka göndər
                                </Button>;*/
                            }
                            else if (btn.selectAccount) {
                                //sign
                                btn_item = (
                                    <Button
                                        size={'large'}
                                        htmlType="submit"
                                        className="blue-button next_btn btn flex align_center justify_center"
                                        // onClick={handleTransactionReq}
                                    >
                                        {t("home.chooseAccounts")}
                                    </Button>
                                )
                            }

                            return btn_item
                        })}
                        <div className={"modalButtonDiv1"}>
                            <Button
                                size={'large'}
                                htmlType="submit"
                                className="light-button refresh_btn next_modal_cancel_btn btn flex align_center justify_center"
                                disabled={loading || loadingApprove}
                                onClick={onCloseModal}
                            >
                                {
                                    props.source ? t("common.close") : t("settings.deactivate")
                                }
                            </Button>
                        </div>
                    </div>
                </div>
            }
        </>
    )
    const { changeStatusHandler } = useActions()

    const onClosePanel = () => {
        setPanel(!activePanel)
    }

    const onClosePanelNotify = () => {
        setPanelNotify(!activePanelNotify)
    }

    return (
        <>
            {nextModalVisible && (
                <Modal
                    title={modalData.modalTitle}
                    closeIcon={<ModalCloseIco />}
                    centered
                    width={props.width || 700}
                    // height={750}

                    visible={nextModalVisible}
                    onOk={onCloseModal}
                    onCancel={onCloseModal}
                    className={`manage_faster_menus swift_modal form_next_modal ${props?.className}`}
                    keyboard={false}
                    focusTriggerAfterClose={false}
                    footer={modalFooter()}

                >
                    <Scrollbar
                        ref={scrollbar}
                        plugins={{
                            disableScroll: { direction: 'x' },
                        }}
                        alwaysShowTracks={true}
                    >
                    <Form layout="vertical" onFinish={(e) => { }} autoComplete="off">
                            {/* groups */}
                            {modalData.groups?.map((row) => {
                                let table_class = ''

                                if (row?.tableHasBorderBottom) {
                                    table_class += ' has_border_bottom '
                                }

                                if (row?.tableHasBorderBottom2) {
                                    table_class += ' has_border_bottom has_border_bottom2 '
                                }

                                if (row?.tableHasBordertop) {
                                    table_class += ' has_border_top has_border_top2 '
                                }

                                if (row?.tableHasMarginBottom) {
                                    table_class += ' has_margin_bottom '
                                }

                                return (
                                    <table
                                        className={`table table-hover swift_table form_next_table ${table_class}`}
                                    >
                                        <tbody>
                                        {row.title && (
                                            <tr>
                                                <td
                                                    className={'table_title'}
                                                    align={'center'}
                                                    colSpan={2}
                                                >
                                                    {
                                                        row.currency ? <div className='currency-title'><span>{row.currency}</span><span>Bank hesabı rekvizitləri</span></div> : <></>
                                                    }
                                                    <Divider
                                                        plain
                                                        orientation="center"
                                                        className={'tab_divider_center'}
                                                    >
                                                        {row.title}
                                                    </Divider>
                                                </td>
                                            </tr>
                                        )}

                                        {row.title === '' && (
                                            <tr>
                                                <td
                                                    className={'table_title'}
                                                    align={'center'}
                                                    colSpan={2}
                                                >
                                                    <Divider
                                                        plain
                                                        orientation="center"
                                                        className={'tab_divider_only'}
                                                    >
                                                        {row.title}
                                                    </Divider>
                                                </td>
                                            </tr>
                                        )}

                                        {row.tableHasDivider && (
                                            <tr>
                                                <td
                                                    className={'table_title'}
                                                    align={'center'}
                                                    colSpan={2}
                                                >
                                                    <Divider
                                                        orientation="center"
                                                        className={'tab_divider_only'}
                                                    />
                                                </td>
                                            </tr>
                                        )}

                                        {row.data?.map((line) => {
                                            return (
                                                line !== undefined ?
                                                    <tr className={line?.rowClass}>
                                                        <td>{line?.label}</td>
                                                        <td>{line?.value}</td>
                                                    </tr> : <></>
                                            )
                                        })}
                                        </tbody>
                                    </table>
                                )
                            })}

                            {/* edv section */}
                            {
                                modalData.edvInfoData !== null && modalData.edvInfoData !== undefined ? (
                                    <div className={'box_row'}>
                                        <div className={'flex direction_column edv_title_box'}>
                                            <h3>{modalData.edvInfoData.title}</h3>
                                            <p>{modalData.edvInfoData.description}</p>
                                        </div>

                                        <table
                                            className={`table table-hover swift_table form_next_table form_next_table_transparent_row`}
                                        >
                                            <tbody>
                                            {modalData.edvInfoData.data?.map((line) => {
                                                return (
                                                    <tr>
                                                        <td>{line?.label}</td>
                                                        <td>{line?.value}</td>
                                                    </tr>
                                                )
                                            })}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : <></>
                            }

                            {props.tableData?.PDF_LIST?.length > 0 && (
                                // <div className={'pdf-div'}>
                                <table
                                    className={
                                        'table swift_table table_pdf modal_pdf '
                                    }
                                >
                                    <tbody>
                                    <tr>
                                        <td>Qoşulmuş PDF</td>
                                        <td>
                                            {props.tableData?.PDF_LIST?.map((line: any) => {
                                                return (line?.mimeType === "application/pdf" ? <div>
                                                    <a type={'button'} onClick={() => props.handleGetPdfAdditional(props.tableData?.ibankRef, line?.fileName)} >
                                                        <p style={{ marginRight: 10 }}>{line?.fileName}</p>
                                                    </a>
                                                </div> : <></>)
                                            })}
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                                // </div>
                            )}

                            {modalData?.pdfFiles?.length > 0 && (
                                // <div className={'pdf-div'}>
                                <table
                                    className={
                                        'table swift_table salary-table table_pdf modal_pdf'
                                    }
                                >
                                    <tbody>
                                    <tr>
                                        <td>Qoşulmuş PDF</td>
                                        <td>
                                            {modalData?.pdfFiles?.map((line: any) => {
                                                return <div>
                                                    <a type={'button'} onClick={() => downloadPDF(line)} >
                                                        <p style={{ marginRight: 10 }}>{line?.label}</p>
                                                    </a>
                                                </div>
                                            })}
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                                // </div>
                            )}

                        </Form>
                    {/*<Scrollbar*/}
                    {/*    ref={scrollbar}*/}
                    {/*    plugins={{*/}
                    {/*        disableScroll: { direction: 'x' },*/}
                    {/*    }}*/}
                    {/*    alwaysShowTracks={true}*/}
                    {/*>*/}
                        {props.transferData && (
                            <><h4 className="table-title">{props.tableTitle}</h4>
                                <TableComponent
                                    columns={props.columnsData}
                                    className={`transfer-table salary-table transfers-table__component  modal-table`}
                                    data={props.transferSp === true ? props.tableData['TRANSACTION_EMPLIST'] : props.tableData}
                                    scroll={{ x: 0 }}
                                    pagination={false}
                                    rowSelection={false} /></>
                        )
                        }
                    {/*</Scrollbar>*/}
                    </Scrollbar>
                </Modal>
            )}

            {asanModalVisible && (
                <Modal
                    title={`ASAN IMZA`}
                    closable={false}
                    // closeIcon={<ModalCloseIco />}
                    centered
                    visible={asanModalVisible}
                    // onOk={onClose}
                    // onCancel={onClose}
                    width={422}
                    // bodyStyle={{height: 700}}
                    className={`manage_faster_menus swift_modal form_next_modal `}
                    keyboard={false}
                    focusTriggerAfterClose={false}
                    footer={false}
                >
                    <div className={'flex direction_column asan_sign_popup'}>
                        <ul className="office-card__list">
                            <li>
                                <img src={asanLogo} alt="asan-logo" />
                            </li>
                            <li>
                                <Tooltip
                                    id="verificationTooltip"
                                    title={text}
                                    placement="topRight"
                                >
                                    <img src={questionMark} alt="question-mark" />
                                </Tooltip>
                            </li>
                        </ul>

                        <p>{LOGIN_PAGE.MESSAGE}</p>
                        <div className="office-card__statistics mt-15 mb-15">
                            Yoxlama kodu
                            <span>{verifyCode}</span>
                        </div>
                        <div className="countdown">
                            <CountdownCircleTimer
                                isPlaying
                                duration={120}
                                size={80}
                                strokeWidth={3}
                                colors={[['#015cd1']]}
                                onComplete={resetFormTimer}
                            >
                                {renderTime}
                            </CountdownCircleTimer>
                        </div>
                    </div>
                </Modal>
            )}

            {otpCodeModalVisible && (
                <Modal
                    title={channel == 'OTP' ? 'SMS-kod ilə imzalama' : 'Google kod ilə imzalama'}
                    closeIcon={<ModalCloseIco />}
                    centered
                    visible={otpCodeModalVisible}
                    onOk={hideOtpCodeModal}
                    onCancel={hideOtpCodeModal}
                    width={props.width || 422}
                    className={`manage_faster_menus swift_modal form_next_modal otp_code_verify_modal`}
                    keyboard={false}
                    focusTriggerAfterClose={false}
                    footer={false}
                    maskClosable={false}
                >
                    <div
                        className={
                            'flex direction_column align_center otp_code_verify_modal_body'
                        }
                    >

                        {channel == 'OTP' ?
                            <p>
                                {t("settings.otpcode1")}{phoneNumber} {t("settings.otpcode2")} <br />
                                {t("settings.otpcode3")}
                            </p>
                            : <p>Xahiş olunur, “Google Authenticator” tətbiqində generasiya olunmuş kodu daxil edəsiniz.</p>
                        }
                        <Form
                            form={form}
                            onSubmit={(e: any) => e.preventDefault()}
                            onFinish={checkOTPCode}
                            shouldAutoFocus={true}
                            autoComplete="off"
                            className={
                                otpCodeHasError
                                    ? 'message-input-form flex direction_column justify_center has_error'
                                    : 'flex direction_column justify_center message-input-form'
                            }
                        >
                            <OtpInput
                                value={otpCode}
                                onChange={handleValue}
                                numInputs={otpNumberCount}
                                inputStyle="otpInput"
                                isInputNum={true}
                                shouldAutoFocus={true}
                                className="message-input-form__input"
                            />

                            {otpCodeHasError && (
                                <span className={'verify_code_error flex full justify_center'}>
                    Yanlış kod daxil edilib!
    </span>
                            )}

                            <div className={'full flex direction_column'}>
                                <ul
                                    className="message-form__details full"
                                    style={{ marginTop: otpCodeHasError ? 16 : 21 }}
                                >
                                    <li className="message-form__time">
                                        <Timer timerEnd={resetFormTimer} reset={reset} />
                                    </li>
                                    <li>
                                        {channel == 'OTP' &&
                                        <a onClick={reSend} className={(smsClicked) ? 'active' : 'disabled'}>SMS kodu yenidən göndər</a>
                                        }
                                    </li>
                                </ul>

                                {/*<Button*/}
                                {/*  type={'ghost'}*/}
                                {/*  className={'transparent resend_verify_code_btn' + smsClicked ? 'active' : 'disabled'}*/}
                                {/*  onClick={reSend}*/}
                                {/*>*/}
                                {/*  SMS kodu yenidən göndər*/}
                                {/*</Button>*/}

                                <div className="login-form__buttons flex justify_center">
                                    <Button
                                        size={'large'}
                                        className="prev ant-btn ant-btn-lg light-button refresh_btn btn flex align_center justify_center"
                                        onClick={hideOtpCodeModal}
                                    >
                                        Geriyə
                                    </Button>
                                    <Button
                                        size={'large'}
                                        className="next ant-btn ant-btn-lg blue-button next_btn btn flex align_center justify_center"
                                        htmlType="submit"
                                    >
                                        Təsdiq et
                                    </Button>
                                </div>
                            </div>
                        </Form>
                    </div>
                </Modal>
            )}

            {showSuccessOrError && (
                <SuccessOrErrorModal
                    visible={showSuccessOrError}
                    modalType={popupType}
                    modalTitle={popupType === 'success' ? 'Köçürmə' : "Diqqət"}
                    modalText={modalText}
                    onClose={() => { onCloseSuccessModal(); onClose() }}
                />
            )}
            {showTimeError && (
                <SuccessOrErrorModal
                    visible={showTimeError}
                    modalType={'error'}
                    modalTitle={t("common.attention")}
                    modalText={t("sima.signError")}
                    onClose={() => { setShowTimeError(false); }}
                    onCancel={() => { setShowTimeError(false); setNextModalVisible(true) }}
                />
            )}
            <SaveAsTemplate
                visible={saveAsTemplatePopupVisible}
                onClose={setSaveAsTemplatePopupVisible}
                trnType={modalData?.modalTitle !== undefined ? modalData?.modalTitle : ""}
                currentForm={props.currentForm}
                tableData={props.tableData}
            />

        </>
    )
}
const mapDispatchToProps = { changeStatusHandler }

export default connect(null, null)(NextModalSalary)
